import { Box, CircularProgress, IconButton, Stack, Typography } from '@mui/material';
import { Image as AntImage } from 'antd';
import React, { CSSProperties, useEffect, useState } from 'react';
import { fetchAndConvertHeicToPng } from 'utils/convertData';
import { sharedImagePreviewConfig } from 'utils/antImagePreviewEnhancements';
export type ImageProp = {
  title?: string;
  url: {
    url: string;
    type: string;
  };
  tag?: string;
  onClickTag?: () => void;
  onClickImage?: () => void;
  width?: number;
  height?: number;
  panoramic?: boolean;
  onDownLoad?: () => void;
  styledImage?: CSSProperties;
  styledWrapper?: CSSProperties;
  disablePreview?: boolean;
};
export const Image = ({
  title,
  url,
  tag,
  onClickTag,
  onClickImage,
  width = 265,
  height = 185,
  onDownLoad,
  styledImage,
  panoramic,
  styledWrapper,
  disablePreview
}: ImageProp) => {
  const [imageSrc, setImageSrc] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const [isHovered, setIsHovered] = useState(false);

  const canHoverPreview = !disablePreview && !onClickImage && !!imageSrc && !loading;
  const showHoverMask = canHoverPreview && isHovered;

  useEffect(() => {
    let revokeUrl: string | undefined;
    setLoading(true);
    async function loadImage() {
      try {
        // if (panoramic && !url.url.includes('blob:') && !url.url.includes('cloudinary.com')) {
        //   const { url: compressUrl } = await compressImage(url.url);
        //   if (compressUrl) {
        //     setImageSrc(compressUrl);
        //   }
        //   return;
        // }
        if (url.type === 'image/heic') {
          const pngUrl = await fetchAndConvertHeicToPng(url.url);
          setImageSrc(pngUrl);
          revokeUrl = pngUrl;
        } else {
          setImageSrc(url.url);
        }
      } finally {
        setLoading(false);
      }
    }
    loadImage();
    return () => {
      if (revokeUrl) URL.revokeObjectURL(revokeUrl);
    };
  }, [url, panoramic]);
  return (
    <Stack gap={1} style={styledWrapper}>
      {title && (
        <Typography color={'#226AAA'} fontSize={'18px'} fontWeight={900}>
          {title}
        </Typography>
      )}
      <Stack
        width={'100%'}
        style={{ position: 'relative', width: 'max-content', ...styledWrapper }}>
        {onDownLoad && (
          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              onDownLoad();
            }}
            style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              background: '#fff',
              zIndex: 3,
              boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
              borderRadius: '50%',
              padding: 6
            }}
            size="small">
            <img src="/icons/icon_download.svg" alt="download" style={{ width: 24, height: 24 }} />
          </IconButton>
        )}
        <Box
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          onClick={() => {
            if (onClickImage) onClickImage();
          }}
          sx={{
            position: 'relative',
            display: 'inline-block',
            cursor: onClickImage || (!disablePreview && imageSrc) ? 'pointer' : 'default'
          }}>
          {disablePreview || onClickImage ? (
            <Box
              component="img"
              alt={title || 'icon-image-room'}
              src={imageSrc || undefined}
              sx={{
                width,
                height,
                maxHeight: height,
                objectFit: 'contain',
                borderRadius: '10px',
                display: 'block',
                ...(styledImage as object)
              }}
            />
          ) : (
            <AntImage
              src={imageSrc || undefined}
              alt={title || 'icon-image-room'}
              width={width}
              height={height}
              style={{
                objectFit: 'contain',
                borderRadius: '10px',
                ...(styledImage as object)
              }}
              preview={imageSrc ? sharedImagePreviewConfig : false}
            />
          )}
          {showHoverMask && (
            <Box
              sx={{
                pointerEvents: 'none',
                position: 'absolute',
                inset: 0,
                bgcolor: 'rgba(0, 0, 0, 0.45)',
                borderRadius: (styledImage?.borderRadius as string | number | undefined) ?? '10px'
              }}
            />
          )}
        </Box>
        {loading && (
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: width,
              height: height,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 2
            }}>
            <CircularProgress />
          </Box>
        )}
      </Stack>
      {tag && (
        <Stack
          onClick={onClickTag && onClickTag}
          style={{ cursor: 'pointer', flexDirection: 'row', gap: '7px', alignItems: 'center' }}>
          <img width={'16px'} height={'16px'} alt={'icon-tag'} src={'/icons/icon_tag.svg'} />
          <Typography color={'#000'} fontSize={'16px'} fontWeight={400}>
            {tag}
          </Typography>
        </Stack>
      )}
    </Stack>
  );
};
